module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "min-width": "1100px"
    }
  }, [_c('Tabs', {
    attrs: {
      "value": _vm.appName
    },
    on: {
      "on-click": _vm.tabChanged
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "我能帮帮忙",
      "name": "I_Can_Help"
    }
  }, [_c('Card', {
    staticClass: "mainBody"
  }, [_c('div', {
    staticClass: "leftPanel"
  }, [_c('div', {
    staticClass: "phoneTitle"
  }, [_c('p', {
    staticStyle: {
      "color": "white",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.publicTitle))])]), _vm._v(" "), _c('draggable', _vm._b({
    staticClass: "list-group",
    attrs: {
      "tag": "ul",
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.menuList),
      callback: function($$v) {
        _vm.menuList = $$v
      },
      expression: "menuList"
    }
  }, 'draggable', _vm.dragOptions, false), [_vm._l((_vm.menuList), function(item, index) {
    return _c('li', {
      key: item.name,
      staticClass: "list-group-item",
      class: _vm.menuSize
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable),
        expression: "!editable"
      }],
      staticClass: "pre_menu_link",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.selectMenu(item, index)
        }
      }
    }, [_c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable),
        expression: "editable"
      }],
      staticClass: "pre_menu_link",
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), (_vm.selectedMenu.name === item.name) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable),
        expression: "!editable"
      }],
      staticClass: "sub_pre_menu"
    }, [(item['sub_button']) ? _c('ul', {
      staticClass: "sub_pre_menu_list"
    }, [_vm._l((item.sub_button), function(element, index2) {
      return _c('li', {
        key: element.name,
        staticClass: "sub-group-item"
      }, [_c('a', {
        staticClass: "pre_menu_link",
        attrs: {
          "href": "javascript:void(0)"
        },
        on: {
          "click": function($event) {
            return _vm.selectSubMenu(element, index, index2)
          }
        }
      }, [_c('span', {
        staticClass: "badge"
      }, [_vm._v(_vm._s(element.name))])])])
    }), _vm._v(" "), (item['sub_button'].length !== 5) ? _c('li', {
      staticClass: "add_list"
    }, [_c('a', {
      staticClass: "add_link",
      attrs: {
        "href": "javascript:void(0)",
        "title": "最多添加5个二级菜单",
        "draggable": "false"
      },
      on: {
        "click": function($event) {
          return _vm.addSubMenu(index)
        }
      }
    }, [_c('i', {
      staticClass: "add_icon"
    })])]) : _vm._e()], 2) : _c('ul', {
      staticClass: "sub_pre_menu_list"
    }, [_c('li', {
      staticClass: "add_list"
    }, [_c('a', {
      staticClass: "add_link",
      attrs: {
        "href": "javascript:void(0)",
        "title": "最多添加5个二级菜单",
        "draggable": "false"
      },
      on: {
        "click": function($event) {
          return _vm.addSubMenu(index)
        }
      }
    }, [_c('i', {
      staticClass: "add_icon"
    })])])]), _vm._v(" "), _c('i', {
      staticClass: "arrow_out"
    }), _vm._v(" "), _c('i', {
      staticClass: "arrow_in"
    })]) : _vm._e()])
  }), _vm._v(" "), (_vm.menuList.length !== 3) ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable),
      expression: "!editable"
    }],
    staticClass: "add_list",
    class: _vm.menuSize
  }, [_c('a', {
    staticClass: "add_link",
    attrs: {
      "href": "javascript:void(0)",
      "title": "最多添加3个一级菜单",
      "draggable": "false"
    },
    on: {
      "click": _vm.addMenu
    }
  }, [_c('i', {
    staticClass: "add_icon"
  })])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "position": "relative",
      "top": "520px"
    }
  }, [(!_vm.editable) ? _c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "default",
      "ghost": ""
    },
    on: {
      "click": _vm.startDrag
    }
  }, [_vm._v("菜单排序")]) : _vm._e(), _vm._v(" "), (_vm.editable) ? _c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "default",
      "ghost": ""
    },
    on: {
      "click": _vm.finishDrag
    }
  }, [_vm._v("完成")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rightPanel"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messageShow.show),
      expression: "messageShow.show"
    }],
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.messageShow.tip))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.messageShow.show),
      expression: "!messageShow.show"
    }],
    staticClass: "edit_area"
  }, [_c('div', {
    staticClass: "edit_area_header"
  }, [_c('div', {
    staticStyle: {
      "height": "20px"
    }
  }, [_c('h3', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.editAreaShow.title) + "名称")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.deletePublicMenu
    }
  }, [_vm._v("删除" + _vm._s(_vm.editAreaShow.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "edit_area_name"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editAreaShow.show),
      expression: "!editAreaShow.show"
    }]
  }, [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("已添加子菜单，仅可设置菜单名称。")]), _c('br')]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "16px",
      "margin-right": "16px"
    }
  }, [_vm._v(_vm._s(_vm.editAreaShow.title) + "名称")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-grid"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": function($event) {
        return _vm.disInRealtime(1)
      }
    },
    model: {
      value: (_vm.selectedBtn.name),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "name", $$v)
      },
      expression: "selectedBtn.name"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "small-title",
    staticStyle: {
      "font": "12px gray",
      "display": "inline-block"
    }
  }, [_vm._v("仅支持中英文和数字，字数不超过4个汉字或8个字母")])], 1)]), _vm._v(" "), (_vm.editAreaShow.show) ? _c('div', {
    staticClass: "edit_area_content"
  }, [_c('Row', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('Col', {
    staticStyle: {
      "font-size": "16px",
      "margin-right": "16px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v(_vm._s(_vm.editAreaShow.title) + "内容")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('RadioGroup', {
    on: {
      "on-change": _vm.changeType
    },
    model: {
      value: (_vm.menuType),
      callback: function($$v) {
        _vm.menuType = $$v
      },
      expression: "menuType"
    }
  }, [_c('Radio', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "label": "click"
    }
  }, [_vm._v("发送消息")]), _vm._v(" "), _c('Radio', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "label": "view"
    }
  }, [_vm._v("跳转网页")]), _vm._v(" "), _c('Radio', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "label": "miniprogram"
    }
  }, [_vm._v("跳转小程序")])], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuType === 'click'),
      expression: "menuType === 'click'"
    }]
  }, [_c('Tabs', {
    attrs: {
      "value": "text"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "图文消息",
      "name": "picandtext",
      "icon": "card"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "paintbrush",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("自建图文")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "share",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("转载文章")])])])])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "文字",
      "name": "text",
      "icon": "ios-paper"
    }
  }, [_c('div', {
    staticClass: "input-area"
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 6
    }
  })], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Col', {
    attrs: {
      "span": "19"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('Col', {
    staticStyle: {
      "color": "#888888"
    },
    attrs: {
      "span": "5"
    }
  }, [_vm._v("还可以输入字")])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "图片",
      "name": "pic",
      "icon": "image"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "image",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("上传图片")])])])])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "语音",
      "name": "voice",
      "icon": "ios-mic"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-mic",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("新建语音")])])])])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "视频",
      "name": "video",
      "icon": "ios-videocam"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-videocam",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("新建视频")])])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuType === 'view'),
      expression: "menuType === 'view'"
    }]
  }, [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("订阅者点击该" + _vm._s(_vm.editAreaShow.title) + "会跳到以下链接")]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("页面地址")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.viewUrl),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "viewUrl", $$v)
      },
      expression: "selectedBtn.viewUrl"
    }
  })], 1), _vm._v(" "), _c('Row', [_c('a', {
    staticClass: "delete-menu",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("从公众号图文消息中选择")])])], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuType === 'miniprogram'),
      expression: "menuType === 'miniprogram'"
    }]
  }, [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("订阅者点击该子菜单会跳到以下小程序")]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("小程序appID")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.appid),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "appid", $$v)
      },
      expression: "selectedBtn.appid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("小程序路径")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.miniProgramPagePath),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "miniProgramPagePath", $$v)
      },
      expression: "selectedBtn.miniProgramPagePath"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("备用网页")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "18"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.miniProgramUrl),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "miniProgramUrl", $$v)
      },
      expression: "selectedBtn.miniProgramUrl"
    }
  })], 1), _vm._v(" "), _c('Row', [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("旧版微信客户端无法支持小程序，用户点击菜单时将会打开备用网页。 ")])])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "edit_area_arrow"
  }, [_c('i', {
    staticClass: "edit_area_arrow_out"
  }), _vm._v(" "), _c('i', {
    staticClass: "edit_area_arrow_in"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "position": "relative",
      "top": "26px"
    }
  }, [_c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "success",
      "ghost": ""
    },
    on: {
      "click": _vm.saveChange
    }
  }, [_vm._v("保存并发布")]), _vm._v(" "), _c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "default",
      "ghost": "",
      "disabled": ""
    }
  }, [_vm._v("预览")])], 1)])])], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "无障碍科技",
      "name": "ACCESSIBILITY_TECHNOLOGY"
    }
  }, [_c('Card', {
    staticClass: "mainBody"
  }, [_c('div', {
    staticClass: "leftPanel"
  }, [_c('div', {
    staticClass: "phoneTitle"
  }, [_c('p', {
    staticStyle: {
      "color": "white",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.publicTitle))])]), _vm._v(" "), _c('draggable', _vm._b({
    staticClass: "list-group",
    attrs: {
      "tag": "ul",
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.menuList),
      callback: function($$v) {
        _vm.menuList = $$v
      },
      expression: "menuList"
    }
  }, 'draggable', _vm.dragOptions, false), [_vm._l((_vm.menuList), function(item, index) {
    return _c('li', {
      key: item.name,
      staticClass: "list-group-item",
      class: _vm.menuSize
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable),
        expression: "!editable"
      }],
      staticClass: "pre_menu_link",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.selectMenu(item, index)
        }
      }
    }, [_c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable),
        expression: "editable"
      }],
      staticClass: "pre_menu_link",
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), (_vm.selectedMenu.name === item.name) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable),
        expression: "!editable"
      }],
      staticClass: "sub_pre_menu"
    }, [(item['sub_button']) ? _c('ul', {
      staticClass: "sub_pre_menu_list"
    }, [_vm._l((item['sub_button']), function(element, index2) {
      return _c('li', {
        key: element.name,
        staticClass: "sub-group-item"
      }, [_c('a', {
        staticClass: "pre_menu_link",
        attrs: {
          "href": "javascript:void(0)"
        },
        on: {
          "click": function($event) {
            return _vm.selectSubMenu(element, index, index2)
          }
        }
      }, [_c('span', {
        staticClass: "badge"
      }, [_vm._v(_vm._s(element.name))])])])
    }), _vm._v(" "), (item['sub_button'].length !== 5) ? _c('li', {
      staticClass: "add_list"
    }, [_c('a', {
      staticClass: "add_link",
      attrs: {
        "href": "javascript:void(0)",
        "title": "最多添加5个二级菜单",
        "draggable": "false"
      },
      on: {
        "click": function($event) {
          return _vm.addSubMenu(index)
        }
      }
    }, [_c('i', {
      staticClass: "add_icon"
    })])]) : _vm._e()], 2) : _c('ul', {
      staticClass: "sub_pre_menu_list"
    }, [_c('li', {
      staticClass: "add_list"
    }, [_c('a', {
      staticClass: "add_link",
      attrs: {
        "href": "javascript:void(0)",
        "title": "最多添加5个二级菜单",
        "draggable": "false"
      },
      on: {
        "click": function($event) {
          return _vm.addSubMenu(index)
        }
      }
    }, [_c('i', {
      staticClass: "add_icon"
    })])])]), _vm._v(" "), _c('i', {
      staticClass: "arrow_out"
    }), _vm._v(" "), _c('i', {
      staticClass: "arrow_in"
    })]) : _vm._e()])
  }), _vm._v(" "), (_vm.menuList.length !== 3) ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable),
      expression: "!editable"
    }],
    staticClass: "add_list",
    class: _vm.menuSize
  }, [_c('a', {
    staticClass: "add_link",
    attrs: {
      "href": "javascript:void(0)",
      "title": "最多添加3个一级菜单",
      "draggable": "false"
    },
    on: {
      "click": _vm.addMenu
    }
  }, [_c('i', {
    staticClass: "add_icon"
  })])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "position": "relative",
      "top": "570px"
    }
  }, [(!_vm.editable) ? _c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "default",
      "ghost": ""
    },
    on: {
      "click": _vm.startDrag
    }
  }, [_vm._v("菜单排序")]) : _vm._e(), _vm._v(" "), (_vm.editable) ? _c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "default",
      "ghost": ""
    },
    on: {
      "click": _vm.finishDrag
    }
  }, [_vm._v("完成")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rightPanel"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messageShow.show),
      expression: "messageShow.show"
    }],
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.messageShow.tip))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.messageShow.show),
      expression: "!messageShow.show"
    }],
    staticClass: "edit_area"
  }, [_c('div', {
    staticClass: "edit_area_header"
  }, [_c('div', {
    staticStyle: {
      "height": "20px"
    }
  }, [_c('h3', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.editAreaShow.title) + "名称")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.deletePublicMenu
    }
  }, [_vm._v("删除" + _vm._s(_vm.editAreaShow.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "edit_area_name"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editAreaShow.show),
      expression: "!editAreaShow.show"
    }]
  }, [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("已添加子菜单，仅可设置菜单名称。")]), _c('br')]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "16px",
      "margin-right": "16px"
    }
  }, [_vm._v(_vm._s(_vm.editAreaShow.title) + "名称")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-grid"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.name),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "name", $$v)
      },
      expression: "selectedBtn.name"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "small-title",
    staticStyle: {
      "font": "12px gray",
      "display": "inline-block"
    }
  }, [_vm._v("仅支持中英文和数字，字数不超过4个汉字或8个字母")])], 1)]), _vm._v(" "), (_vm.editAreaShow.show) ? _c('div', {
    staticClass: "edit_area_content"
  }, [_c('Row', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('Col', {
    staticStyle: {
      "font-size": "16px",
      "margin-right": "16px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v(_vm._s(_vm.editAreaShow.title) + "内容")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('RadioGroup', {
    on: {
      "on-change": _vm.changeType
    },
    model: {
      value: (_vm.menuType),
      callback: function($$v) {
        _vm.menuType = $$v
      },
      expression: "menuType"
    }
  }, [_c('Radio', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "label": "click"
    }
  }, [_vm._v("发送消息")]), _vm._v(" "), _c('Radio', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "label": "view"
    }
  }, [_vm._v("跳转网页")]), _vm._v(" "), _c('Radio', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "label": "miniprogram"
    }
  }, [_vm._v("跳转小程序")])], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuType === 'click'),
      expression: "menuType === 'click'"
    }]
  }, [_c('Tabs', {
    attrs: {
      "value": "text"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "图文消息",
      "name": "picandtext",
      "icon": "card"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "paintbrush",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("自建图文")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "share",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("转载文章")])])])])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "文字",
      "name": "text",
      "icon": "ios-paper"
    }
  }, [_c('div', {
    staticClass: "input-area"
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 6
    }
  })], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Col', {
    attrs: {
      "span": "19"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('Col', {
    staticStyle: {
      "color": "#888888"
    },
    attrs: {
      "span": "5"
    }
  }, [_vm._v("还可以输入字")])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "图片",
      "name": "pic",
      "icon": "image"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "image",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("上传图片")])])])])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "语音",
      "name": "voice",
      "icon": "ios-mic"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-mic",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("新建语音")])])])])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "视频",
      "name": "video",
      "icon": "ios-videocam"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-videocam",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("新建视频")])])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuType === 'view'),
      expression: "menuType === 'view'"
    }]
  }, [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("订阅者点击该" + _vm._s(_vm.editAreaShow.title) + "会跳到以下链接")]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("页面地址")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.viewUrl),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "viewUrl", $$v)
      },
      expression: "selectedBtn.viewUrl"
    }
  })], 1), _vm._v(" "), _c('Row', [_c('a', {
    staticClass: "delete-menu",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("从公众号图文消息中选择")])])], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuType === 'miniprogram'),
      expression: "menuType === 'miniprogram'"
    }]
  }, [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("订阅者点击该子菜单会跳到以下小程序")]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("小程序appID")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.appid),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "appid", $$v)
      },
      expression: "selectedBtn.appid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("小程序路径")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.miniProgramPagePath),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "miniProgramPagePath", $$v)
      },
      expression: "selectedBtn.miniProgramPagePath"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("备用网页")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "18"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.miniProgramUrl),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "miniProgramUrl", $$v)
      },
      expression: "selectedBtn.miniProgramUrl"
    }
  })], 1), _vm._v(" "), _c('Row', [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("旧版微信客户端无法支持小程序，用户点击菜单时将会打开备用网页。 ")])])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "edit_area_arrow"
  }, [_c('i', {
    staticClass: "edit_area_arrow_out"
  }), _vm._v(" "), _c('i', {
    staticClass: "edit_area_arrow_in"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "position": "relative",
      "top": "26px"
    }
  }, [_c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "success",
      "ghost": ""
    },
    on: {
      "click": _vm.saveChange
    }
  }, [_vm._v("保存并发布")]), _vm._v(" "), _c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "default",
      "ghost": "",
      "disabled": ""
    }
  }, [_vm._v("预览")])], 1)])])], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "启明瞳",
      "name": "qmtfwh"
    }
  }, [_c('Card', {
    staticClass: "mainBody"
  }, [_c('div', {
    staticClass: "leftPanel"
  }, [_c('div', {
    staticClass: "phoneTitle"
  }, [_c('p', {
    staticStyle: {
      "color": "white",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.publicTitle))])]), _vm._v(" "), _c('draggable', _vm._b({
    staticClass: "list-group",
    attrs: {
      "tag": "ul",
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.menuList),
      callback: function($$v) {
        _vm.menuList = $$v
      },
      expression: "menuList"
    }
  }, 'draggable', _vm.dragOptions, false), [_vm._l((_vm.menuList), function(item, index) {
    return _c('li', {
      key: item.name,
      staticClass: "list-group-item",
      class: _vm.menuSize
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable),
        expression: "!editable"
      }],
      staticClass: "pre_menu_link",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.selectMenu(item, index)
        }
      }
    }, [_c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable),
        expression: "editable"
      }],
      staticClass: "pre_menu_link",
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), (_vm.selectedMenu.name === item.name) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable),
        expression: "!editable"
      }],
      staticClass: "sub_pre_menu"
    }, [(item['sub_button']) ? _c('ul', {
      staticClass: "sub_pre_menu_list"
    }, [_vm._l((item['sub_button']), function(element, index2) {
      return _c('li', {
        key: element.name,
        staticClass: "sub-group-item"
      }, [_c('a', {
        staticClass: "pre_menu_link",
        attrs: {
          "href": "javascript:void(0)"
        },
        on: {
          "click": function($event) {
            return _vm.selectSubMenu(element, index, index2)
          }
        }
      }, [_c('span', {
        staticClass: "badge"
      }, [_vm._v(_vm._s(element.name))])])])
    }), _vm._v(" "), (item['sub_button'].length !== 5) ? _c('li', {
      staticClass: "add_list"
    }, [_c('a', {
      staticClass: "add_link",
      attrs: {
        "href": "javascript:void(0)",
        "title": "最多添加5个二级菜单",
        "draggable": "false"
      },
      on: {
        "click": function($event) {
          return _vm.addSubMenu(index)
        }
      }
    }, [_c('i', {
      staticClass: "add_icon"
    })])]) : _vm._e()], 2) : _c('ul', {
      staticClass: "sub_pre_menu_list"
    }, [_c('li', {
      staticClass: "add_list"
    }, [_c('a', {
      staticClass: "add_link",
      attrs: {
        "href": "javascript:void(0)",
        "title": "最多添加5个二级菜单",
        "draggable": "false"
      },
      on: {
        "click": function($event) {
          return _vm.addSubMenu(index)
        }
      }
    }, [_c('i', {
      staticClass: "add_icon"
    })])])]), _vm._v(" "), _c('i', {
      staticClass: "arrow_out"
    }), _vm._v(" "), _c('i', {
      staticClass: "arrow_in"
    })]) : _vm._e()])
  }), _vm._v(" "), (_vm.menuList.length !== 3) ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable),
      expression: "!editable"
    }],
    staticClass: "add_list",
    class: _vm.menuSize
  }, [_c('a', {
    staticClass: "add_link",
    attrs: {
      "href": "javascript:void(0)",
      "title": "最多添加3个一级菜单",
      "draggable": "false"
    },
    on: {
      "click": _vm.addMenu
    }
  }, [_c('i', {
    staticClass: "add_icon"
  })])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "position": "relative",
      "top": "570px"
    }
  }, [(!_vm.editable) ? _c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "default",
      "ghost": ""
    },
    on: {
      "click": _vm.startDrag
    }
  }, [_vm._v("菜单排序")]) : _vm._e(), _vm._v(" "), (_vm.editable) ? _c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "default",
      "ghost": ""
    },
    on: {
      "click": _vm.finishDrag
    }
  }, [_vm._v("完成")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rightPanel"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messageShow.show),
      expression: "messageShow.show"
    }],
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.messageShow.tip))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.messageShow.show),
      expression: "!messageShow.show"
    }],
    staticClass: "edit_area"
  }, [_c('div', {
    staticClass: "edit_area_header"
  }, [_c('div', {
    staticStyle: {
      "height": "20px"
    }
  }, [_c('h3', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.editAreaShow.title) + "名称")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.deletePublicMenu
    }
  }, [_vm._v("删除" + _vm._s(_vm.editAreaShow.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "edit_area_name"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editAreaShow.show),
      expression: "!editAreaShow.show"
    }]
  }, [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("已添加子菜单，仅可设置菜单名称。")]), _c('br')]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "16px",
      "margin-right": "16px"
    }
  }, [_vm._v(_vm._s(_vm.editAreaShow.title) + "名称")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-grid"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.name),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "name", $$v)
      },
      expression: "selectedBtn.name"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "small-title",
    staticStyle: {
      "font": "12px gray",
      "display": "inline-block"
    }
  }, [_vm._v("仅支持中英文和数字，字数不超过4个汉字或8个字母")])], 1)]), _vm._v(" "), (_vm.editAreaShow.show) ? _c('div', {
    staticClass: "edit_area_content"
  }, [_c('Row', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('Col', {
    staticStyle: {
      "font-size": "16px",
      "margin-right": "16px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v(_vm._s(_vm.editAreaShow.title) + "内容")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('RadioGroup', {
    on: {
      "on-change": _vm.changeType
    },
    model: {
      value: (_vm.menuType),
      callback: function($$v) {
        _vm.menuType = $$v
      },
      expression: "menuType"
    }
  }, [_c('Radio', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "label": "click"
    }
  }, [_vm._v("发送消息")]), _vm._v(" "), _c('Radio', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "label": "view"
    }
  }, [_vm._v("跳转网页")]), _vm._v(" "), _c('Radio', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "label": "miniprogram"
    }
  }, [_vm._v("跳转小程序")])], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuType === 'click'),
      expression: "menuType === 'click'"
    }]
  }, [_c('Tabs', {
    attrs: {
      "value": "text"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "图文消息",
      "name": "picandtext",
      "icon": "card"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "paintbrush",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("自建图文")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "share",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("转载文章")])])])])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "文字",
      "name": "text",
      "icon": "ios-paper"
    }
  }, [_c('div', {
    staticClass: "input-area"
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 6
    }
  })], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Col', {
    attrs: {
      "span": "19"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('Col', {
    staticStyle: {
      "color": "#888888"
    },
    attrs: {
      "span": "5"
    }
  }, [_vm._v("还可以输入字")])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "图片",
      "name": "pic",
      "icon": "image"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "image",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("上传图片")])])])])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "语音",
      "name": "voice",
      "icon": "ios-mic"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-mic",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("新建语音")])])])])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "视频",
      "name": "video",
      "icon": "ios-videocam"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-videocam",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("新建视频")])])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuType === 'view'),
      expression: "menuType === 'view'"
    }]
  }, [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("订阅者点击该" + _vm._s(_vm.editAreaShow.title) + "会跳到以下链接")]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("页面地址")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.viewUrl),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "viewUrl", $$v)
      },
      expression: "selectedBtn.viewUrl"
    }
  })], 1), _vm._v(" "), _c('Row', [_c('a', {
    staticClass: "delete-menu",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("从公众号图文消息中选择")])])], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuType === 'miniprogram'),
      expression: "menuType === 'miniprogram'"
    }]
  }, [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("订阅者点击该子菜单会跳到以下小程序")]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("小程序appID")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.appid),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "appid", $$v)
      },
      expression: "selectedBtn.appid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("小程序路径")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.miniProgramPagePath),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "miniProgramPagePath", $$v)
      },
      expression: "selectedBtn.miniProgramPagePath"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("备用网页")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "18"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.miniProgramUrl),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "miniProgramUrl", $$v)
      },
      expression: "selectedBtn.miniProgramUrl"
    }
  })], 1), _vm._v(" "), _c('Row', [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("旧版微信客户端无法支持小程序，用户点击菜单时将会打开备用网页。 ")])])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "edit_area_arrow"
  }, [_c('i', {
    staticClass: "edit_area_arrow_out"
  }), _vm._v(" "), _c('i', {
    staticClass: "edit_area_arrow_in"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "position": "relative",
      "top": "26px"
    }
  }, [_c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "success",
      "ghost": ""
    },
    on: {
      "click": _vm.saveChange
    }
  }, [_vm._v("保存并发布")]), _vm._v(" "), _c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "default",
      "ghost": "",
      "disabled": ""
    }
  }, [_vm._v("预览")])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "helpInfo",
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://kf.qq.com/faq/120911VrYVrA150210BBJvei.html"
    }
  }, [_vm._v("自定义菜单使用说明\n          "), _c('Icon', {
    attrs: {
      "type": "ios-book-outline"
    }
  })], 1)])], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "温馨提示"
    },
    on: {
      "on-ok": _vm.handleConfirm
    },
    model: {
      value: (_vm.handleTips.show),
      callback: function($$v) {
        _vm.$set(_vm.handleTips, "show", $$v)
      },
      expression: "handleTips.show"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/gantan.png"),
      "alt": "",
      "width": "50px",
      "height": "50px"
    }
  })]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "18"
    }
  }, [_c('Row', [_vm._v(_vm._s(_vm.handleTips.title))]), _vm._v(" "), _c('Row', {
    staticClass: "small-title"
  }, [_vm._v(_vm._s(_vm.handleTips.tips))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ed2a828","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/components/setup-blocks/publicSetting.vue
// module id = a78U
// module chunks = 0